import gql from 'graphql-tag';

export const DataClassificationEnabledQuery = gql`
	query DataClassificationEnabledQuery {
		isDataClassificationEnabled
	}
`;
